<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     备案查询容器
  +---------------------------------------------------------------------------------------
-->

<template>
  <!-- 弹窗形态：嵌套 Dialog 容器 -->
  <el-dialog
    v-if="type === 'dialog'"
    class="record-check"
    width="1500px"
    append-to-body
    :visible.sync="dialogShow"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <div class="contianer" style="min-height: 550px;">
      <record-check-content ref="recordCheckContent" type="dialog" :companyid="companyid" @report="toReport" />
    </div>
  </el-dialog>

  <div v-else class="record-check contianer" style="height: 540px;">
    <record-check-content @report="toReport" />
  </div>
</template>

<script>

export default {
  name: 'RecordCheck',

  components: {
    RecordCheckContent: () => import('./RecordCheckContent'),
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    companyid: {
      type: Number,
      default: 0
    },
    
    type: {
      type: String,
      default: '' //dialog
    }
  },

  data() {
    return {
    }
  },

  computed: {
    dialogShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },

  mounted() {
    // 关键：mounted + $nextTick 确保子组件挂载完成
    this.$nextTick(() => {
      if (this.companyid && this.$refs.recordCheckContent) {
        this.$refs.recordCheckContent.checkCompany(this.companyid)
      }
    })
  },

  created() {
  },

  methods: {
    toReport(clueCompany) {
      this.$emit('report', clueCompany)
    },
  }
}
</script>

<style lang="scss" scoped>
.record-check {
  padding: 30px 20px;
  /deep/ .el-dialog__header {
    padding: 0;
    padding-bottom: 0px;
  }
  /deep/ .el-dialog__body {
    padding: 0 0;
  }
}
.contianer {
  padding: 30px 20px 40px;
  background-size: 100% 100%;
  background-image: url("../../../assets/record-check-bg.jpg");
}
</style>